import { ease } from './circuits.js';

const halfSeparation = 1.85;
const centerLimit = 4.9-halfSeparation;

export function battleProgress(action, u) {
  if (action.tactic === 'switchback') {
    // Keep the full longitudinal gap while the two paths cross. The late-apex
    // car only starts gaining after it has turned underneath the defender.
    return ease((u-.59)/.24);
  }
  if (action.tactic === 's-duel') {
    // Establish overlap at the first apex; finish the move on the second exit.
    return .42*ease((u-.15)/.24) + .58*ease((u-.50)/.30);
  }
  return ease((u-.15)/.70);
}

export function positionBattle(attacker, defender, action, u, line) {
  const aLine = line(attacker.distance), dLine = line(defender.distance);
  // Smooth saturation avoids a steering impulse when the preferred line
  // reaches the shared corridor's bound during a braking-zone maneuver.
  const center = centerLimit*Math.tanh((aLine+dLine)/(2*centerLimit));
  const isCorner = action.tactic === 'switchback' || action.tactic === 's-duel';
  // Begin unwinding once the passing car has longitudinal clearance, leaving
  // enough time to rejoin without a last-moment swerve under braking.
  const release = isCorner ? .85 : .64;
  const open = action.tactic === 'slipstream' ? ease((u-.08)/.34) : ease(u/(isCorner ? .18 : .42));
  const spread = open*(1-ease((u-release)/(1-release)));
  const side = action.tactic === 'switchback' ? 1-2*ease((u-.38)/.20) : action.side;
  attacker.lane = aLine + (center+side*halfSeparation-aLine)*spread;
  defender.lane = dLine + (center-side*halfSeparation-dLine)*spread;
  attacker.tactic = defender.tactic = action.tactic;
  attacker.maneuver = u >= release ? 'return' : u < .28 ? 'pull-out' : 'alongside';
  defender.maneuver = 'defend';
  if (action.tactic === 'switchback' && u >= .38 && u <= .59) attacker.maneuver = 'cutback';
  if (action.tactic === 'slipstream' && u < .08) attacker.maneuver = 'tow';
}
